<template lang="pug">
  LayoutPlain
    .container.align__center
      .row.justify-content-center
        .col-lg-6.col-md-10
          .auth--logo: img(src='../assets/images/logo-auth.png')
          .pad_t--20
            img(src='../assets/images/loading-ripple.svg', style="width: 60px;")
            .pad_t--15.text--size_18: strong Logging you in to Online Platform...
            .text--color_grey.pad_t--5.text--size_15 This may take a moment.

</template>



<script>

import { mapActions } from 'vuex';
import { checkIEVersion } from '@/lib/helper';



export default {
  data: () => ({
    redirectTo: null,
    vendorToken: null,
  }),


  methods: {
    ...mapActions('auth', [
      'logIn', 'fetchMorningStarToken', 'fetchUserInfo', 'startPingingVendor'
    ]),
    ...mapActions('stock', {
      fetchAllStocks: 'fetchAll',
    }),
    ...mapActions('notification', {
      fetchAllNotifications: 'fetchAll',
    }),
    ...mapActions('withdrawal', [
      'triggerDataQueue'
    ]),


    async LOGIN_USER() {
      try {
        if(!this.vendorToken) {
          throw new Error(`Token not provided in the 'authToken' URL query`);
        }

        await this.logIn(this.vendorToken);

        await Promise.all([
          this.fetchMorningStarToken(),
          this.fetchUserInfo(),
          this.fetchAllStocks(),
          this.fetchAllNotifications(),
          this.startPingingVendor()
        ])

        // Trigger data queue needs to be outside of the promise.all
        // because can only be done after fetchUserInfo has completed
        await this.triggerDataQueue();

        this.$router.push({ name: this.redirectTo || 'dashboard' });

      } catch(e) {
        let _errMsg = e.message || 'An error has occurred. Please try again later by refreshing the page';
        this.$router.push({ name: 'logout', params: { errorMessage: _errMsg } });

      }
    },

    SET_AUTH_TOKEN() {
      let { authToken } = this.$route.query;

      if(authToken) {
        this.vendorToken = authToken;
      }
    },

    SET_REDIRECT() {
      let { redirectTo } = this.$route.query;
      const storageRedirectTo = localStorage.getItem('ropRedirectName');

      if(redirectTo) {
        this.redirectTo = redirectTo;
      }

      if(storageRedirectTo) {
        this.redirectTo = storageRedirectTo;
      }
    },
  },

  beforeMount() {
    let _ieVersion = checkIEVersion();
    
    if(typeof _ieVersion === 'number' && _ieVersion < 12) {
      this.$router.push('/upgrade-browser');

    } else {
      this.SET_AUTH_TOKEN();
      this.SET_REDIRECT();
      this.LOGIN_USER();
      
    }
  },
}
</script>




<style lang="scss" scoped>
  .auth--logo {
    text-align: center;

    img {
      width: auto;
      height: 68px;
    }
  }
</style>
